import React from "react";
import { useRecoilState } from "recoil";
import Fade from "../components/Fade";
import OriginalButton from "../components/OriginalButton";
import { selectionAtom } from "../store/selection.atom";

const Post = () => {
  const [selection] = useRecoilState(selectionAtom);

  return (
    <Fade isVisible={selection.blog !== undefined}>
      <div className="custom-scroll h-[calc(100dvh-64.8px-64.8px-88.3px)] overflow-y-scroll bg-white p-5 md:h-[calc(100dvh-103px-69px)]">
        <div className="pb-5 text-xl font-bold">{selection.blog?.title}</div>
        {selection.blog?.content}
      </div>
      <div className="flex items-center justify-center justify-self-end border-t-[1px] border-t-rss-border p-5 md:hidden">
        <OriginalButton />
      </div>
    </Fade>
  );
};

export default Post;
